<template>
  <main>
    <wl-banner bgUrl='/static/img/product/aqjc/banner.png' :bannerData='bannerData' paddingTop='214px'></wl-banner>
    <breadcrumb></breadcrumb>
    <section class="page1 bg" v-lazy:background-image="'/static/img/product/aqjc/bg1.png'">
      <article class="container flex">
        <wl-title :title='page1Data.title' :desc='page1Data.desc' class="mytitle"></wl-title>
      </article>
    </section>
    <section class="page2">
      <article class="container">
        <wl-title title=' 实验室安全检查业务流程' :isNeedDesc=false></wl-title>
        <section class="img">
          <img v-lazy="'/static/img/product/aqjc/p1.png'" alt=" 实验室安全检查业务流程">
        </section>
      </article>
    </section>
    <section class="page3 bg" v-lazy:background-image="'/static/img/product/bg-cptx-677.png'">
      <article class="container">
        <wl-title title='产品特性' :isNeedDesc=false></wl-title>
        <section class="flexWrap">
          <section class="box" v-for="(item,index) in page3Data" :key="item.key" @mouseenter="mouseEnter(index)" @mouseleave="page3HoverId = null">
            <section class="_icon " :style="page3HoverId===index?`background-position: -${72+144*index}px 0px;`:`background-position: -${144*index}px 0px;`"></section>
            <h3>{{item.title}}</h3>
            <p>{{item.desc}}</p>
          </section>
        </section>
      </article>
    </section>
    <submit-page></submit-page>
  </main>
</template>

<script>
export default {
  name: 'aqjcManageSystem',
  data() {
    return {
      bannerData: {
        title: '实验室安全检查管理系统',
        desc: '强化安全检查工作\n提高安全检查效率\n实现安全检查业务闭环管理'
      },
      page1Data: {
        title: '实验室安全检查管理系统',
        desc: '实验室安全检查管理系统是通过构建统一的实验室安全检查标准和依据项目库，建立安全检查计划和检查内容，移动式检查，实时填入检查情况，检查评价，整个和落实情况等，自动汇总形成检查报告，提高实验室安全检查效率和实验室安全检查管理水平。'
      },
      page3Data: [
        { key: 'aqjc-icon1', title: '多样化检查依据', desc: '内置300+教育部安全检查指标' },
        { key: 'aqjc-icon2', title: '多模式检查计划', desc: '支持日常检查、实验室自查\n校级检查、专项检查' },
        { key: 'aqjc-icon3', title: '多终端支持方便快捷', desc: '电脑、手机多终端支持\n现场随拍随记，一键上传' },
        { key: 'aqjc-icon4', title: '多维度统计分析', desc: '可指定自动生成检查报告\n按照房间多维度统计隐患问题' },
      ],
      page3HoverId: null,
    }
  },
  methods: {
    mouseEnter(index) {
      this.page3HoverId = index
    },
  }
}
</script>

<style lang='scss' scoped>
._icon {
  background: url("/static/img/product/aqjc/icon.png");
  display: inline-block;
}
main {
  background: #fbfbff;
}
h3 {
  font-size: 22px;
  font-weight: 500;
  color: #262626;
  line-height: 22px;
  padding-bottom: 12px;
  padding-top: 16px;
}
p {
  font-size: 20px;
  color: #8e8e8e;
  line-height: 30px;
  white-space: pre-line;
}
.pt-30 {
  padding-top: 32px !important;
}
.page1 {
  height: 545px;
  padding-top: 164px;
  text-align: left;
  .mytitle {
    width: 600px;
    margin-left: 670px;
    ::v-deep strong {
      color: #8e8e8e;
      line-height: 38px;
      padding-top: 23px;
    }
  }
}
.page2 {
  padding-top: 69px;
  padding-bottom: 136px;
  .img {
    margin-top: 95px;
    width: 1260px;
  }
}
.page3 {
  height: 677px;
  padding-top: 136px;
  .flexWrap {
    padding-top: 65px;
  }
  .box {
    width: 300px;
    height: 300px;
    background: #ffffff;
    border-radius: 14px;
    padding: 0 14px;
    padding-top: 47px;
    ._icon {
      width: 72px;
      height: 72px;
    }
    &:hover {
      background: linear-gradient( 360deg, #FF9222 0%, #F56728 100%);
      h3 {
        color: #fff;
      }
      p {
        color: #fff;
      }
    }
  }
}
</style>
